import {useEffect, useState} from 'react';

import api from 'services/api/api';
import {tdsUrlPath} from 'utils/string';

export const useGetTextFromApi = (url: string | undefined) => {
  const [text, setText] = useState('');
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getTextAsync = async () => {
      try {
        // in case the error state has persisted from a previous render
        setError(false);
        if (!url) {
          throw new Error();
        }
        setLoading(true);
        const response = await api.get(tdsUrlPath(url), {
          headers: {
            'Content-Type': 'text/plain',
            accept: 'application/json',
          },
        });
        if (response.status !== 200 || typeof response.data !== 'string') {
          throw new Error();
        }
        setText(response.data);
      } catch (e) {
        setError(true);
        setText('Something went wrong');
      } finally {
        setLoading(false);
      }
    };
    getTextAsync();
  }, [url]);

  return {text, error, loading};
};
